var render = function render(){var _vm=this,_c=_vm._self._c;return _c('mdb-container',{staticClass:"mt-5"},[_c('h1',[_vm._v(_vm._s(_vm.$t('pageNotFound.title')))]),_c('p',{staticClass:"font-weight-normal"},[_vm._v(_vm._s(_vm.$t('pageNotFound.paragraph', {url: _vm.url})))]),_c('btn',{attrs:{"color":"info"},on:{"click":function($event){return _vm.$router.go(-1)}}},[_vm._v(_vm._s(_vm.$t('pageNotFound.btn')))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }